import list from './list'
import receive from './receive'
import payment from './payment'
import receipt from './receipt'

export default {
    list,
    receive,
    payment,
    receipt
}



// WEBPACK FOOTER //
// ./src/api/apis/self/statement/index.js